import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../axios/axiosInstance";

export const fetchCredits = createAsyncThunk(
  "credits/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/billing/credits");
      return {
        balance:     res.data.creditBalance ?? 0,
        autoRecharge: res.data.autoRecharge || { enabled: false, threshold: 5, amount: 100 },
      };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch credits");
    }
  }
);

const creditsSlice = createSlice({
  name: "credits",
  initialState: {
    balance:      0,
    autoRecharge: { enabled: false, threshold: 5, amount: 100 },
    loading:      false,
    lastFetched:  null,
  },
  reducers: {
    setBalance(state, action) {
      state.balance = action.payload;
    },
    setAutoRecharge(state, action) {
      state.autoRecharge = { ...state.autoRecharge, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCredits.pending,   (state) => { state.loading = true; })
      .addCase(fetchCredits.fulfilled, (state, action) => {
        state.loading      = false;
        state.balance      = action.payload.balance;
        state.autoRecharge = action.payload.autoRecharge;
        state.lastFetched  = Date.now();
      })
      .addCase(fetchCredits.rejected,  (state) => { state.loading = false; });
  },
});

export const { setBalance, setAutoRecharge } = creditsSlice.actions;
export default creditsSlice.reducer;
